module.exports = __webpack_public_path__ + "static/media/retirement-object-3-1-0.65959ab2.png";